// pure helpers for the teacher "Payment details" page (moved off the teacher profile).

export const PAYMENT_DETAILS_PATH = '/teacherprofile/payment-details';

export const payment_details_url = (uuid) =>
  `${PAYMENT_DETAILS_PATH}?id=${encodeURIComponent(uuid)}`;

export const teacher_profile_url = (uuid) => `/teacherprofile?id=${encodeURIComponent(uuid)}`;

export const teacher_id_from_search = (search) => {
  const id = new URLSearchParams(search || '').get('id');
  return id ? id.trim() : '';
};

export const teacher_display_name = (details) =>
  `${details?.first_name || ''} ${details?.last_name || ''}`.trim();

// Redux holds one shared teacher profile; it is only usable when it is this teacher's.
export const profile_for = (details, uuid) =>
  details && uuid && details.uuid === uuid ? details : null;

// Fetch once per id, and not while another teacher's fetch is in flight (it would overwrite ours).
export const needs_profile_fetch = ({ details, status, uuid, fetched_for }) =>
  !!uuid && !profile_for(details, uuid) && status !== 'loading' && fetched_for !== uuid;

// 'invalid' | 'loading' | 'error' | 'ready'. Our fetch settled without this teacher = error, not a spinner.
export const page_state = ({ details, status, uuid, fetched_for }) => {
  if (!uuid) return 'invalid';
  if (profile_for(details, uuid)) return 'ready';
  if (fetched_for === uuid && status !== 'loading') return 'error';
  return 'loading';
};
